export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_PROBATION":
      return [...state, action.payload.probation];
    case "UPDATE_PROBATIONS":
      return action.payload.probations;
    case "DELETE_PROBATION":
      return state.filter((probation) => {
        return probation.id !== action.payload.probation.id
      });
    default:
      return state;
  }
}
